// extracted by mini-css-extract-plugin
module.exports = {"text":"CopyableText_text__2csnK","copyButton":"CopyableText_copyButton__UZAe5","copied":"CopyableText_copied__23ZQ_","showOnHover":"CopyableText_showOnHover__3Gbp_"};